import React from 'react';
import * as styles from './Icon.module.css';

export type IconType =
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'arrow-down'
  | 'arrow-filled-left'
  | 'arrow-filled-right'
  | 'arrow-filled-up'
  | 'arrow-filled-down'
  | 'uncheck_circle'
  | 'check_circle'
  | 'chevron-right'
  | 'close';

interface IconProps {
  type: IconType;
  size?: number;
  color?: string;
  className?: string;
}

export const Icon: React.FC<IconProps> = ({
  type,
  size = 1.5, // デフォルト値を1.5remに変更
  color = '#000000',
  className,
}) => {
  // 左向き矢印を基準とする（アウトライン）
  const arrowPath =
    'M15.7049 16.59L11.1249 12L15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59Z';

  // 塗りつぶし矢印（左向きを基準とする）
  const arrowFilledPath = 'M14.5 7.75439L9.5 12.7544L14.5 17.7544V7.75439Z';

  // 方向に応じてCSSクラスを追加
  const getRotationClass = () => {
    switch (type) {
      case 'arrow-left':
        return '';
      case 'arrow-right':
        return styles.rotate180;
      case 'arrow-up':
        return styles.rotate270;
      case 'arrow-down':
        return styles.rotate90;
      case 'arrow-filled-left':
        return '';
      case 'arrow-filled-right':
        return styles.rotate180;
      case 'arrow-filled-up':
        return styles.rotate270;
      case 'arrow-filled-down':
        return styles.rotate90;
      default:
        return '';
    }
  };

  // uncheck_circleアイコンの場合
  if (type === 'uncheck_circle') {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={`${size}rem`}
        height={`${size}rem`}
        viewBox='0 0 24 24'
        fill='none'
        className={className || ''}
      >
        <path
          d='M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12Z'
          fill='#D9D9D9'
        />
        <path
          d='M16.59 7.58008L10 14.1701L7.41 11.5901L6 13.0001L10 17.0001L18 9.00008L16.59 7.58008Z'
          fill='white'
        />
      </svg>
    );
  }

  // check_circleアイコンの場合
  if (type === 'check_circle') {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={`${size}rem`}
        height={`${size}rem`}
        viewBox='0 0 24 24'
        fill='none'
        className={className || ''}
      >
        <path
          d='M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12Z'
          fill='#42DEC4'
        />
        <path
          d='M16.59 7.58008L10 14.1701L7.41 11.5901L6 13.0001L10 17.0001L18 9.00008L16.59 7.58008Z'
          fill='white'
        />
      </svg>
    );
  }

  // chevron-rightアイコンの場合
  if (type === 'chevron-right') {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={`${size}rem`}
        height={`${size}rem`}
        viewBox='0 0 24 24'
        fill='none'
        className={className || ''}
      >
        <path
          d='M9.5 7L14.5 12L9.5 17'
          stroke={color}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  }

  // closeアイコンの場合
  if (type === 'close') {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={`${size}rem`}
        height={`${size}rem`}
        viewBox='0 0 24 24'
        fill='none'
        className={className || ''}
      >
        <path
          d='M6 6L18 18M6 18L18 6'
          stroke={color}
          strokeWidth='2.625'
          strokeLinecap='round'
        />
      </svg>
    );
  }

  // arrow-filledアイコンの場合
  const isArrowFilled = type.startsWith('arrow-filled');

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${size}rem`}
      height={`${size}rem`}
      viewBox='0 0 24 24'
      fill='none'
      className={`${className || ''} ${getRotationClass()}`.trim()}
    >
      <path d={isArrowFilled ? arrowFilledPath : arrowPath} fill={color} />
    </svg>
  );
};

export default Icon;
